/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { StyledModal, Text, ModalActions, Button } from 'sarsaparilla';
import CommonFilter from '../common/CommonFilter';
import {
    FCFS_TYPE,
    FIRST_COME_FIRST_SERVE_TYPE,
} from '../../../constants/filters/camping';
import { FiltersTypeProps } from '../../../types/filters';

const FCFS_KEY = FIRST_COME_FIRST_SERVE_TYPE[0].key;

export type FirstComeFirstServedProps = {
    /** The host's filter slice. Only `fg`, the flat list of applied filter keys, is read here. */
    search: any;
    aggregations?: { [key: string]: number };
    onChange?: (v: React.ChangeEvent<HTMLInputElement>, k: any) => void;
    /**
     * Whether the host has a check-in/check-out date range set. The date fields
     * live in a different place in every host store, so each one derives this
     * itself rather than having this component reach into a store shape it
     * cannot know about.
     */
    hasDates: boolean;
};

function FirstComeFirstServedFilters({
    search,
    aggregations,
    onChange,
    hasDates,
}: FirstComeFirstServedProps) {
    const [openShowAvailableModal, setOpenShowAvailableModal] = React.useState(false);
    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        item: FiltersTypeProps
    ) => {
        const fg: string[] = search?.fg ?? [];
        // Dates are only required to apply the filter, never to clear one that
        // is already applied.
        if (!hasDates && item.key === FCFS_KEY && !fg.includes(FCFS_KEY)) {
            setOpenShowAvailableModal(true);
            return;
        }
        if (onChange) {
            onChange(event, item);
        }
    };
    return (
        <div className="mb-5">
            <CommonFilter
                aggregations={aggregations}
                search={search}
                onChange={handleChange}
                filters={FCFS_TYPE}
                title="First-Come, First-Served"
                columns={1}
                hasDivider={false}
                keepEnabled
            />
            <StyledModal
                size="md"
                isOpen={openShowAvailableModal}
                heading="Show First-come, First-served"
                onRequestClose={() => setOpenShowAvailableModal(false)}
            >
                <Text>Add Dates to Filter by First-come, First-served.</Text>
                <ModalActions>
                    <Button onClick={() => setOpenShowAvailableModal(false)}>OK</Button>
                </ModalActions>
            </StyledModal>
        </div>
    );
}

export default FirstComeFirstServedFilters;

// cSpell:ignore FCFS
